import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG } from '../../../_metronic/helpers'
import { taxcodeInitialsForApp, taxcodeInitialsForUpdate } from './interfaces/taxcodeClass';
import { addAccountTaxCodeAsync, updateAccountTaxCodeAsync } from './taxcodeSlice'
import { Formik } from 'formik';
import * as yup from 'yup';
import { ShowToast } from '../../../common/Toastr';
import { determineCommaSeprater, FormatInvoiceDecimalNumber, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const TaxCodeForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { AccountTaxZoneId, t, oncloseModal } = props;
    const dispatch = useAppDispatch();
    const { selectedRecord, isLoading, taxcodeList } = useAppSelector((state) => state.taxcode);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(taxcodeInitialsForApp);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
         const { cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(taxcodeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
          //  stateItem.Formula = FormatInvoiceDecimalNumber(cultureInfoName.toString(), stateItem.Formula, decimalPlaces);
            stateItem.Formula = stateItem.Formula.replace(/(\d+(\.\d+)?)/g,(match: string) => 
                FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(match),match.includes(".") ? match.split(".")[1].length : 0));
                // FormatInvoiceDecimalNumber(cultureInfoName.toString(), parseFloat(match), decimalPlaces));
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData({ ...taxcodeInitialsForApp, 'AccountTaxZoneId': AccountTaxZoneId });
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();
 
    }, [selectedRecord])


    const handleSubmit = (values: any) => {
       
        const formattedValues = {
            ...values,
            Formula: values.Formula
                ? values.Formula.replace(/(\d+[.,]?\d*)/g, (match:any) =>  parseLocalizedNumber(match))
                : values.Formula
        };
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountTaxCodeAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Tax Code Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addAccountTaxCodeAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Tax Code Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (taxcodeList.length > 0) {
            let index = 0;
            taxcodeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(taxcodeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    TaxCode: yup
                        .string()
                        .label
                        // (t('TaxCode'))
                        (getValueFromResource('TaxCode',dispatch, t))
                        .trim()
                        .required
                        // (t('Tax code field is required')),
                        (getValueFromResource('Tax code field is required',dispatch, t)),
                    Formula: yup
                        .string()
                        .label(getValueFromResource('Formula', dispatch, t))
                        .trim()
                        .required(
                            getValueFromResource('Formula field is required', dispatch, t)
                        )
                        .test(
                            'culture-format-check',
                            () => {
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                return isComma
                                    ? "Only numbers and comma (,) are allowed."
                                    : "Only numbers and dot (.) allowed";
                            },
                            (value) => {
                                if (!value) return true;

                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                const regex = isComma
                                    ? /^[a-zA-Z\s+\-*/()]*\d+(,\d+)?([a-zA-Z\s+\-*/()]*\d+(,\d+)?)*$/
                                    : /^[a-zA-Z\s+\-*/()]*\d+(\.\d+)?([a-zA-Z\s+\-*/()]*\d+(\.\d+)?)*$/;

                                return regex.test(value);
                            }
                        )


                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                    //  t('Update Tax Code')
                                                    getValueFromResource('Update Tax Code',dispatch, t) : 
                                                    //   t('Add Tax Code')} 
                                                    getValueFromResource('Add Tax Code',dispatch, t)}
                                                      </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="modal-body">

                                                    <div className="mb-0">
                                                        <label className="fs-7 fs-7 fw-normal mb-2">
                                                            {/* {t('Tax Code')} */}
                                                            {getValueFromResource('Tax Code',dispatch, t)}
                                                            </label>
                                                        <input
                                                            type="text"
                                                            className="form-control fs-7 fw-normal"
                                                            id='TaxCode'
                                                            name='TaxCode'
                                                            value={values.TaxCode}
                                                            onChange={handleChange('TaxCode')}
                                                            ref={defaultFocusRef}
                                                        />
                                                    </div>
                                                    <div style={{ paddingRight: 5}}>
                                                        {touched.TaxCode && errors.TaxCode &&
                                                            <p className='errorMsg'>{errors.TaxCode as string}</p>
                                                        }
                                                    </div>
                                                    <div className="mb-0 mt-2">
                                                        <label className="fs-7 fs-7 fw-normal mb-2 mt-2 d-flex align-items-center gap-1">
                                                            {/* {t('Formula')} */}
                                                            {getValueFromResource('Formula', dispatch, t)}
                                                            <div
                                                                style={{ marginBottom: "2px" }}
                                                                data-tooltip-id="tooltip-taxForm"
                                                                data-tooltip-content={getValueFromResource('Define the tax calculation formula using system variables. Use net to represent the net amount before tax. Operators such as *, +, and numeric values can be used to calculate tax dynamically. Available Field Reference: net (Net Amount) Example: net * 0.015 calculates a 1.5% tax on the net amount.', dispatch, t)}
                                                            >
                                                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                            </div>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control fs-7 fw-normal mb-2"
                                                            id='Formula'
                                                            name='Formula'
                                                            value={values.Formula}
                                                            onChange={handleChange('Formula')}
                                                            onBlur={() => setFieldTouched('Formula')}
                                                        />
                                                    </div>
                                                    <div style={{ paddingRight: 5}}>
                                                        {touched.Formula && errors.Formula &&
                                                            <p className='errorMsg'>{errors.Formula as string}</p>
                                                        }
                                                    </div>

                                                    {Object.keys(selectedRecord).length > 0 ? (
                                                                    disabledCount !== 1 ? <div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div> : taxcodeList.find(x => x.AccountTaxCodeId === values.AccountTaxCodeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div>)
                                                                ) : null}
                                                </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel',dispatch, t)}
                                                    </button>
                                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                    {/* {t('Save')}   */}
                                                    {getValueFromResource('Save',dispatch, t)}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </form>
                    </Fragment>
                )}
            </Formik>
            <ReactTooltip
                id="tooltip-taxForm"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}
export default TaxCodeForm;